import { useApiMutation, useApiQuery } from "../services/react-query";

export const useGetPolls = (params) =>
  useApiQuery({
    queryOptions: { queryKey: ["polls", params] },
    fetchOptions: {
      url: "/polls",
      method: "GET",
      params,
    },
  });

export const useGetPoll = (pollId) =>
  useApiQuery({
    queryOptions: { queryKey: ["poll", pollId], enabled: !!pollId },
    fetchOptions: { url: `/polls/${pollId}`, method: "GET" },
  });

export const useGetPollResults = (pollId) => {
  return useApiQuery({
    queryOptions: { queryKey: ["pollResults", pollId], enabled: !!pollId },
    fetchOptions: { url: `/polls/${pollId}/results`, method: "GET" },
  });
};
export const useCreatePoll = (data) => {
  return useApiMutation({
    mutationOptions: { mutationKey: "useCreatePoll", data },
    fetchOptions: { url: "/polls", method: "POST" },
    invalidateQueryKeys: [["polls"]],
    successMessage: { title: "Poll has been created", color: "green" },
  });
};

export const useUpdatePoll = (data) => {
  return useApiMutation({
    mutationOptions: { mutationKey: "useUpdatePoll", data },
    fetchOptions: {
      url: `/polls/${data.id}`,
      method: "PATCH",
    },
    invalidateQueryKeys: [
      ["polls"],
      ["poll", data.id],
      ["pollResults", data.id],
      ["available-follow-ups"],
    ],
    successMessage: {
      title: "Poll has been updated",
      color: "green",
    },
    data,
  });
};

export const useDeletePoll = () => {
  return useApiMutation({
    fetchOptions: {
      url: `/polls`,
      method: "DELETE",
    },
    invalidateQueryKeys: [["polls"], ["available-follow-ups"]],
    successMessage: {
      title: "Poll has been deleted",
      color: "green",
    },
  });
};

export const useUpdatePollStatus = (data) => {
  return useApiMutation({
    mutationOptions: { mutationKey: "useUpdatePollStatusBySessionId", data },
    fetchOptions: {
      url: `/polls/status/session/${data.sessionId}`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["polls"], ["poll"], ["pollResults"]],
    successMessage: {
      title: "Polls status has been updated",
      color: "green",
    },
    data,
  });
};

export const useCreateShareLink = (pollId) => {
  return useApiMutation({
    fetchOptions: {
      url: `/polls/${pollId}/share`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["pollShareLink", pollId]],
    successMessage: {
      title: "Share link created successfully",
      color: "green",
    },
  });
};

export const useDeleteShareLink = (pollId) => {
  return useApiMutation({
    fetchOptions: {
      url: `/polls/${pollId}/share`,
      method: "DELETE",
    },
    invalidateQueryKeys: [["pollShareLink", pollId]],
    successMessage: {
      title: "Share link deleted successfully",
      color: "green",
    },
  });
};

export const useGetShareLink = (pollId) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["pollShareLink", pollId],
      enabled: !!pollId,
    },
    fetchOptions: {
      url: `/polls/${pollId}/share`,
      method: "GET",
    },
  });
};

export const useGetPublicPollResults = (shareToken) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["publicPollResults", shareToken],
      enabled: !!shareToken,
      refetchInterval: 5000,
    },
    fetchOptions: {
      url: `/public/poll-results/${shareToken}`,
      method: "GET",
    },
  });
};

export const useReorderPolls = () => {
  return useApiMutation({
    fetchOptions: {
      url: `/polls/reorder`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["polls"]],
    successMessage: {
      title: "Polls order has been updated",
      color: "green",
    },
  });
};

export const useGetAvailableFollowUpPolls = ({
  eventId,
  sessionId,
  excludePollId,
}) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["available-follow-ups", eventId, sessionId, excludePollId],
      enabled: !!eventId && !!sessionId && !!excludePollId,
    },
    fetchOptions: {
      url: "/polls/available-follow-ups",
      method: "GET",
      params: { eventId, sessionId, excludePollId },
    },
  });
